export default __webpack_public_path__ + "static/media/promo-ice-breaker.20063d87.png";